import { FormBuilder, FormGroup } from '@angular/forms';
import { Component, OnInit, Input } from '@angular/core';
import { StoreCommonService } from '../../../../services/store/store-common.service';
import { Router } from '@angular/router';
import { CalendarGroupStoreList } from '../../../../models/calendar-group.model';
import { CalendarGroupService } from '../../../../services/calendar-group/calendar-group.service';
import { CalendarGroupStoreService } from '../../../../services/calendar-group/calendar-group-store.service';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-store-common-calendars',
  templateUrl: './store-common-calendars.component.html',
  providers: []
})
export class StoreCommonCalendarsComponent implements OnInit {

  @Input() editMode: boolean;
  @Input() storeId: any;

  form: FormGroup

  fields: any;
  invalidSubmit: boolean;

  public addDialog = false;
  public calendarGroupStoreList: CalendarGroupStoreList[] = [];
  public calendarGroupList: Array<{ value: string, label: string}>;
  addCalendarTitle: string;

  constructor (
    private router: Router,
    public calendarGroupStoreSrv: CalendarGroupStoreService,
    private calendarGroupSrv: CalendarGroupService,
    private storeSrv: StoreCommonService,
    private fb: FormBuilder,
    private translate: TranslateService,
  ) { }

  ngOnInit(): void {
    this.loadData();
    this.loadValidation();

    this.translate.get([
      'calendarList.add_title',
    ]).subscribe((res) => {
      this.addCalendarTitle = res['calendarList.add_title'];
    });

    this.form = this.fb.group({
      calendar_group_id: null,
      start_date: null
    });

  }

  loadValidation() {
    this.calendarGroupStoreSrv.getFields().subscribe(res => {
      this.fields = res;
    });
  }

  loadData() {
    this.storeSrv.getCalendarGroupList(this.storeId).subscribe(calendarGroupStoreList => {
      this.calendarGroupStoreList = calendarGroupStoreList;
    });
  }

  openAddCalendarGroupDialog() {
    this.form = this.fb.group({
      calendar_group_id: null,
      start_date: null
    });
    this.calendarGroupList = [];
    this.calendarGroupList.push({ label: 'Select...', value: null });

    this.calendarGroupSrv.getAll().subscribe(groups => {
      for (let group of groups) {
        this.calendarGroupList.push({ label: `${group.code} - ${group.description}`, value: group.id.toString() });
      }
      this.addDialog = true;
    });
  }

  addCalendarGroupStore(calendarGroupSelected, dateStart) {

    if (!this.form.valid) {
      this.invalidSubmit = true;
      return;
    }

    const calendarGroupStore = {
      store_id: +this.storeId,
      calendar_group_id: +calendarGroupSelected.value,
      start_date: moment(dateStart.value).format('YYYY-MM-DD').toString()
    };

    this.calendarGroupStoreSrv.post(calendarGroupStore).subscribe(() => {
      this.loadData();
    });

    this.addDialog = false;
  }

  deleteCalendarGroupStore(calendarGroupStore: CalendarGroupStoreList) {
    this.calendarGroupStoreSrv.delete(calendarGroupStore.id).subscribe(() => {
      this.loadData();
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/views/administration/store/store-common-calendars/store-common-calendars.component.ts